<template>
    <!--
            作者：kmdshop
            时间：2019-10-25
            描述：门店-订单核销记录
        -->
    <div class="user">

      <div class="common-seach-wrap">
        <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="下单人姓名">
            <el-input v-model="formInline.search" placeholder="请输入下单人姓名"></el-input>
          </el-form-item>
          <el-form-item label="订单号">
            <el-input v-model="formInline.order" placeholder="请输入订单号"></el-input>
          </el-form-item>
          <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              size="small"
              v-model="formInline.time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
        <div class="common-level-rail" style="margin-right:20px;">
            <el-button size="small" @click="batchExport">批量导出</el-button>
            <el-button size="danger" @click="batchDelte">批量删除</el-button>
          </div>
      </div>



      <!--内容-->
      <div class="product-content">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading"  @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="45"></el-table-column>
            <el-table-column prop="order_no" label="订单号"></el-table-column>
            <el-table-column prop="nickname" label="下单用户"></el-table-column>
            <el-table-column prop="pay_type" label="支付方式">
              <template #default="scope">
                {{ getPayTypeText(scope.row.pay_type) }}
              </template>
            </el-table-column>
              <el-table-column prop="pay_price" label="支付定金金额"></el-table-column>
              <el-table-column prop="total_price" label="总价"></el-table-column>
               <el-table-column label="还需支付">
            <template #default="scope">
              {{ (scope.row.total_price - scope.row.pay_price).toFixed(2) }}
            </template>
          </el-table-column>
            <el-table-column prop="pay_status" label="支付状态">
              <template #default="scope">
                {{ getPayStatusText(scope.row.pay_status) }}
              </template>
            </el-table-column>
           <el-table-column prop="transaction_id" label="支付交易号">
  <template #default="scope">
    <el-tooltip 
      :content="scope.row.transaction_id ? '点击复制' : '无交易号'" 
      placement="top"
    >
      <el-button 
        type="text" 
        size="mini" 
        @click="copyTransactionId(scope.row.transaction_id)"
        :disabled="!scope.row.transaction_id"
      >
        {{ scope.row.transaction_id}}
        <i 
          v-if="scope.row.transaction_id" 
          class="el-icon-document-copy"
        ></i>
      </el-button>
    </el-tooltip>
  </template>
</el-table-column>
            <el-table-column prop="pay_time" label="支付时间"></el-table-column>
         
             <el-table-column prop="create_time" label="创建时间"></el-table-column>
            <el-table-column prop="remark" label="备注"></el-table-column>
            <el-table-column label="操作" width="120" fixed="right">
              <template #default="scope">

              <el-button 
      type="text" 
      size="small" 
      @click="showTravelers(scope.row)"
    >
      查看出行人
    </el-button>
                <!-- 只有未申请退款(0)或审核不通过(3)的订单才能退款 -->
                  <el-button type="text" size="small" @click="openEditPriceDialog(scope.row)">
                修改总价
              </el-button>
               <el-button 
    type="text"
    v-if="scope.row.is_refund === 1"
    size="small" 
    @click="handleRefund(scope.row)"
  >
    退款
  </el-button>
                <!-- <el-button
      v-if="scope.row.is_refund === 1"
      type="text"
      size="small"
      @click="openRejectDialog(scope.row)"
    >
      拒绝退款
    </el-button> -->
                <!-- 已申请退款的状态显示 -->
                 <span v-if="scope.row.is_refund === 2">已退款</span>
              </template>
            </el-table-column>



            <div v-if="dialogVisible" class="modal-mask">
    <div class="modal-container">
      <h3>拒绝退款</h3>
      <textarea v-model="rejectForm.reject_val"></textarea>
      <div class="modal-actions">
        <button @click="dialogVisible = false">取消</button>
        <button @click="submitReject">确认</button>
      </div>
    </div>
  </div>
          </el-table>

        </div>

        <!--分页-->
        <div class="pagination">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-sizes="[20, 100,500, 1000]"
         layout="total,sizes, prev, pager, next, jumper "
            :total="totalDataNumber">
          </el-pagination>
        </div>
      </div>

      <!-- 添加出行人弹窗 -->
<el-dialog
  title="出行人信息"
  :visible.sync="travelerDialogVisible"
  width="70%"
>
  <el-table :data="currentTravelers" border>
    <el-table-column prop="name" label="姓名" width="120"></el-table-column>
    <el-table-column prop="age" label="年龄" width="80"></el-table-column>
    <el-table-column prop="code" label="身份证号" width="200"></el-table-column>
    <el-table-column prop="phone" label="联系电话"></el-table-column>
    <el-table-column prop="height" label="身高(cm)"></el-table-column>
  </el-table>
  <span slot="footer" class="dialog-footer">
    <el-button @click="travelerDialogVisible = false">关闭</el-button>
  </span>
</el-dialog>

       <el-dialog title="修改订单总价" :visible.sync="editPriceDialogVisible" width="30%">
      <el-form :model="editPriceForm" label-width="100px">
        <el-form-item label="当前总价">
          <el-input v-model="editPriceForm.oldTotalPrice" disabled></el-input>
        </el-form-item>
        <el-form-item label="新总价" prop="newTotalPrice" 
          :rules="[{ required: true, message: '请输入新总价' }, 
                  { type: 'number', message: '必须为数字值', transform: value => Number(value) },
                  { validator: validatePrice }]">
          <el-input v-model.number="editPriceForm.newTotalPrice" placeholder="请输入新总价"></el-input>
        </el-form-item>
        <el-form-item label="还需支付">
          {{ (editPriceForm.newTotalPrice - editPriceForm.payPrice).toFixed(2) }}
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editPriceDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitEditPrice">确 定</el-button>
      </span>
    </el-dialog>

     <el-dialog
    title="退款确认"
    :visible.sync="refundDialogVisible"
    width="30%"
    @close="handleRefundClose"
  >
    <div>
      <p>确定要跳转到微信支付退款页面吗？</p>
      <p>交易号：{{ currentTransactionId }}</p>
      <p v-if="copySuccess" style="color: #67C23A;">交易号已自动复制</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="refundDialogVisible = false">取消</el-button>
      <el-button type="primary" @click="confirmRefund">确认</el-button>
    </span>
  </el-dialog>

    </div>
  </template>

  <script>
    import StoreApi from '@/api/store.js';
    import qs from 'qs';
    import { ref } from 'vue'
import CouponUsedLogVue from '../../plus/coupon/coupon/CouponUsedLog.vue';
    export default {
      data() {
        return {
          /*是否加载完成*/
          loading: true,
          /*列表数据*/
          tableData: [],
          /*所属门店数据*/
          storeList: [],
          /*一页多少条*/
          pageSize: 20,
          /*一共多少条数据*/
          totalDataNumber: 0,
          /*当前是第几页*/
          curPage: 1,
          editPriceDialogVisible: false,
           travelerDialogVisible: false, // 控制出行人弹窗显示
    currentTravelers: [], // 当前显示的出行人列表
      editPriceForm: {
        orderId: '',
        oldTotalPrice: 0,
        newTotalPrice: 0,
        payPrice: 0
      },
       refundDialogVisible: false,
      currentTransactionId: '',
      copySuccess: false,
          /*横向表单数据模型*/
          formInline: {
            store_id: '',
            search: '',
            order:"",
            time:""
          },
          /*是否打开添加弹窗*/
          open_add: false,
          /*是否打开编辑弹窗*/
          open_edit: false,
          /*当前编辑的对象*/
          userModel: {},
            /*选中的*/
          multipleSelection: [],
          dialogVisible: false,
          rejectForm: {
            pay_order_id: '',
            order_no: '',
            reject_val: ''
          }
        };
      },
      created() {

        /*获取列表*/
        this.getTableList();

      },
      methods: {

        /*选择第几页*/
        handleCurrentChange(val) {
          let self = this;
          self.curPage = val;
          self.loading = true;
          self.getTableList();
        },
         showTravelers(row) {
    // 从line_orders中提取所有出行人
    const allTravelers = [];
    if (row.line_orders && row.line_orders.length > 0) {
      row.line_orders.forEach(lineOrder => {
        if (lineOrder.participants && lineOrder.participants.length > 0) {
          allTravelers.push(...lineOrder.participants);
        }
      });
    }
    
    if (allTravelers.length === 0) {
      this.$message.warning('该订单没有出行人信息');
      return;
    }
    
    this.currentTravelers = allTravelers;
    this.travelerDialogVisible = true;
  },
        openRejectDialog(row){
          this.rejectForm = {
            pay_order_id: row.pay_order_id,
            order_no: row.order_no,
            reject_val: ''
          }
          this.dialogVisible = true
          console.log(this.dialogVisible);
        },

         openEditPriceDialog(row) {
      this.editPriceForm = {
        orderId: row.pay_order_id,
        oldTotalPrice: row.total_price,
        newTotalPrice: row.total_price,
        payPrice: row.pay_price
      };
      this.editPriceDialogVisible = true;
    },
    
    // 验证价格
    validatePrice(rule, value, callback) {
      if (value < this.editPriceForm.payPrice) {
        callback(new Error('总价不能小于已支付金额'));
      } else {
        callback();
      }
    },

      copyTransactionId(text) {
      if (!text) {
        this.copySuccess = false;
        return;
      }
      
      navigator.clipboard.writeText(text)
        .then(() => {
          this.copySuccess = true;
        })
        .catch(() => {
          // 兼容旧版浏览器
          const textarea = document.createElement('textarea');
          textarea.value = text;
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand('copy');
          document.body.removeChild(textarea);
          this.copySuccess = true;
        });
    },

    
    // 处理退款跳转
    handleRefund(row) {
      if (!row.transaction_id) {
        this.$message.warning('该订单没有交易号');
        return;
      }
      
      this.currentTransactionId = row.transaction_id;
      this.copyTransactionId(row.transaction_id);
      this.refundDialogVisible = true;
    },
    
    
    confirmRefund() {
      window.open(`https://pay.weixin.qq.com/?transaction_id=${this.currentTransactionId}`, '_blank');
      this.refundDialogVisible = false;
    },
    
    handleRefundClose() {
      this.currentTransactionId = '';
      this.copySuccess = false;
    },
    
    // 提交修改总价
    submitEditPrice() {
      
          this.loading = true;
          
          console.log(this.editPriceForm.orderId);
          
          StoreApi.updateOrderPrice({
            order_id: this.editPriceForm.orderId,
            total_price: this.editPriceForm.newTotalPrice
          }).then(response => {
            this.$message.success('修改总价成功');
            this.editPriceDialogVisible = false;
            this.getTableList(); // 刷新列表
          }).catch(error => {
            this.$message.error(error.message || '修改失败');
          }).finally(() => {
            this.loading = false;
          });
    },
        // 提交拒绝退款
  submitReject() {
    if (!this.rejectForm.reject_val) {
      this.$message.warning('请填写拒绝原因')
      return
    }

    this.$confirm('确定要拒绝该退款申请吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.loading = true

      // 调用API
      // rejectRefund({
      //   order_id: this.rejectForm.pay_order_id,
      //   reject_val: this.rejectForm.reject_val
      // }).then(response => {
      //   this.$message.success('拒绝退款成功')
      //   this.rejectDialogVisible = false
      //   this.getTableData() // 刷新表格数据
      // }).catch(error => {
      //   this.$message.error(error.message || '操作失败')
      // }).finally(() => {
      //   this.loading = false
      // })
    })
  },

        getPayTypeText(type) {
          const payTypeMap = {
            10: '余额',
            20: '微信',
            30: '支付宝',
            40: '花呗',
            50: 'app微信',
            60: 'app支付宝'
          };
          return payTypeMap[type] || type;
        },

        getPayStatusText(status) {
          const statusMap = {
            10: '待支付',
            20: '已支付',
            30: '退还已返还',
          };
          return statusMap[status] || status;
        },
     /*选择数据*/
     handleSelectionChange(e) {
        this.multipleSelection = e;
      },

        /*每页多少条*/
        handleSizeChange(val) {
          this.curPage = 1;
          this.pageSize = val;
          this.getTableList();
        },

        /*获取列表*/
        getTableList() {
          let self = this;
          let Params = self.formInline;
          Params.page = self.curPage;
          Params.list_rows = self.pageSize;
           self.loading = true;
           StoreApi.orderList(Params, true)
           .then(data => {
            self.loading = false;
            self.storeList = data.data.store_list.data
           })
          StoreApi.payOrderlist(Params,true)
            .then(data => {
              self.loading = false;
              console.log("data.data.shop_list.data",data.data)
              self.tableData = data.data.list;
              self.totalDataNumber = data.data.list.total || 0;
            })
            .catch(error => {
              self.loading = false;
            });
        },
      batchExport() {
        
  // 获取选中的订单ID
  let ids = this.multipleSelection.map(item => item.pay_order_id);
  
  if (ids.length === 0) {
    this.$message.error('请选择要导出的订单');
    return;
  }

  // 构建查询参数 - 确保使用后端期望的参数名
  let params = {
    search: this.formInline.search,
    order_no: this.formInline.order, // 注意参数名是否匹配后端
    order_ids: ids.join(','), // 使用后端期望的参数名
    page: this.curPage,
    page_size: this.pageSize
  };

  console.log('111111111',params);
  

  // 处理时间范围参数
  if (this.formInline.time && this.formInline.time.length === 2) {
    params.start_time = this.formInline.time[0] + ' 00:00:00';
    params.end_time = this.formInline.time[1] + ' 23:59:59';
  }

  // // 构建导出URL - 确保路由正确
  let baseUrl = window.location.protocol + '//' + window.location.host;
  let queryString = qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true });
  
  // // 添加调试信息
  console.log('导出请求参数:', params);
  console.log('导出URL:', `${baseUrl}/index.php/shop/product.product/exportPayOrderWithLineInfo?${queryString}`);
  
  window.location.href = `${baseUrl}/index.php/shop/product.product/exportPayOrderWithLineInfo?${queryString}`;
},
     batchDelte() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning('请至少选择一条订单');
        return;
      }

      this.$confirm('确定要删除选中的订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;

        // 获取选中的订单ID数组
        const orderIds = this.multipleSelection.map(item => item.pay_order_id);

        // 调用API删除订单
        StoreApi.batchDeleteOrder({ order_ids: orderIds })
          .then(response => {
            this.$message.success(response.msg);
            // 刷新表格数据
            this.getTableList();
            // 清空选中项
            this.multipleSelection = [];
          })
          .catch(error => {
            this.$message.error(error.message || '删除失败');
          })
          .finally(() => {
            this.loading = false;
          });
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
        /*搜索查询*/
        onSubmit() {
          this.curPage = 1;
          this.getTableList();
        },

      }
    };
  </script>

  <style>
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* 出行人表格样式 */
.traveler-table {
  margin-top: 20px;
}

.traveler-table .el-table {
  margin-top: 10px;
}

.modal-container {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/store/order/pay.vue